import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadNavigationDataService {

  private loadingNavigationDataTimeout: any;
  private showNavigationDataWarning: boolean = false;

  constructor() {}

  public startLoadingTimer() {
    this.loadingNavigationDataTimeout = setTimeout(() => {
      this.showNavigationDataWarning = true;
    }, 10 * 1000)
  }

  public endLoadingTimer(): void {
    this.showNavigationDataWarning = false;
    clearTimeout(this.loadingNavigationDataTimeout);
  }

  public getNavigationDataWarningStatus(): boolean {
    return this.showNavigationDataWarning;
  }

}
